import { createAction } from 'redux-actions';
import {
	SET_QUOTES_DATA,
	START_CHART_SOCKET,
	STOP_CHART_SOCKET,
	SET_CONNECTION_STATUS,
} from './constants';

export const SocketConnected = createAction(
	SET_CONNECTION_STATUS,
	(connected: boolean) => ({connected})
)

export const stopChartSocket = createAction(
	STOP_CHART_SOCKET,
	(params: any) => params,
);

export const startChartSocket = createAction(
	START_CHART_SOCKET,
	(params: any) => params,
);

export const setQuoteData = createAction(
	SET_QUOTES_DATA,
	(params: any) => params,
)
